export const API = 'https://auction-oozf.onrender.com'
